<template>
  <v-card elevation="0">
    <v-card-title>
      <h4>{{ matrixElement.file.name }}</h4>
    </v-card-title>
    <v-card-text>
      <v-alert v-if="displayAlert" :type="alertType" small :tile="true" class="mb-0 rounded-t">
        {{ matrixElement.status.message }}
      </v-alert>
      <control-report :matrixIndex="index"></control-report>
    </v-card-text>
  </v-card>
</template>

<script lang="ts">
import Vue from 'vue';
import { getStatusColor, matrix, MatrixElement } from '@/modules/matrix';
import ControlReport from '@/components/control-report/control-report.vue';

export default Vue.extend({
  components: {
    ControlReport
  },
  props: {
    index: {
      type: Number,
      required: true
    }
  },
  computed: {
    matrixElement(): MatrixElement {
      return matrix.elements[this.index];
    },
    displayAlert(): boolean {
      return !!this.matrixElement.status.message;
    },
    alertType(): string {
      return getStatusColor(this.index);
    }
  }
});
</script>
